export const Heading = ({ children, className, as, ...rest }) => {
  const Component = as || 'span'
  return (
    <Component
      className={`text-4xl sm:text-3xl font-semibold  ${
        className || 'text-gray-50'
      }`}
      {...rest}
    >
      {children}
    </Component>
  )
}

export const Subheading = ({ children, className, as, ...rest }) => {
  const Component = as || 'span'
  return (
    <Component
      className={`text-lg sm:text-xl font-medium  ${
        className || 'text-gray-50'
      }`}
      {...rest}
    >
      {children}
    </Component>
  )
}
